import { defineComponent } from 'vue';
export default defineComponent({
    name: 'CatalogItem',
    emits: {
        addToCart: (payload) => true,
        viewDetails: (payload) => true,
        addToWishlist: (payload) => true,
    },
    props: {
        host: {
            type: String,
            required: true,
        },
        lang: {
            type: String,
            required: true,
        },
        product: {
            type: Object,
            required: true,
        },
        priceFormatter: {
            type: Object,
            required: true,
        },
        taxApplier: {
            type: Function,
            required: true,
        },
        showAddToCartBtn: {
            type: Boolean,
            default: true,
        },
        showQuantityInput: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            selectedId: this.product.id,
            quantity: 1,
        };
    },
    computed: {
        productLink() {
            switch (this.lang) {
                case 'it-IT':
                    return 'p';
                case 'en-GB':
                    return 'en/p';
                default:
                    return 'p';
            }
        },
        brand() {
            return this.product.taxonomies?.['brand_taxonomy']?.[0].name ?? '';
        },
        category() {
            let cat = this.product.taxonomies['product_cat']?.[0];
            if (!cat) {
                return undefined;
            }
            while (cat.children.length !== 0) {
                cat = cat.children[0];
            }
            return cat.name;
        },
        firstCategory() {
            return this.product.taxonomies?.['product_cat']?.[0]?.name;
        },
        image() {
            return (this.product.image?.sizes['shop_catalog']?.link ??
                this.product.image?.link);
        },
        minPrice() {
            return this.stringifyPrice(this.product.minPrice, this.product.taxClass);
        },
        minBasePrice() {
            return this.stringifyPrice(this.product.minBasePrice, this.product.taxClass);
        },
        maxPrice() {
            return this.stringifyPrice(this.product.maxPrice, this.product.taxClass);
        },
        maxBasePrice() {
            return this.stringifyPrice(this.product.maxBasePrice, this.product.taxClass);
        },
        ratingStarClasses() {
            const classes = [];
            for (let i = 1; i <= 5; i++) {
                if (i <= this.product.averageRating) {
                    classes.push('fas fa-star');
                }
                else if (i <= this.product.averageRating + 0.5) {
                    classes.push('fas fa-star-half-alt');
                }
                else {
                    classes.push('far fa-star');
                }
            }
            return classes;
        },
        minSalePercentage() {
            return Math.round(100 - (this.product.minPrice * 100) / this.product.minBasePrice).toString();
        },
        maxSalePercentage() {
            return Math.round(100 - (this.product.maxPrice * 100) / this.product.maxBasePrice).toString();
        },
        jvmWishListExists() {
            return typeof JVMWooCommerceWishlist === 'object';
        },
    },
    mounted() {
        // todo: this is not efficient
        if (this.jvmWishListExists) {
            JVMWooCommerceWishlist.build();
        }
        if (this.product.type === 'variable' &&
            this.product.catalogData?.variations) {
            for (const v of this.product.catalogData.variations.products) {
                if (v.stockStatus === 'instock') {
                    this.selectedId = v.id.toString();
                    break;
                }
            }
        }
    },
    methods: {
        stringifyPrice(price, taxClass) {
            return this.priceFormatter.format(this.taxApplier(price, taxClass));
        },
        increaseQuantity(amount) {
            this.quantity += amount;
            if (this.quantity < 1) {
                this.quantity = 1;
            }
        },
    },
});
